import type { Referee } from '@/components/ReferenceDetails/types'
import type { IncomeAccountantReference } from '@/types/Activity'
import type { IncomeProperties } from '@/types/Income'
import { formatDate, parseDate } from '@/utils/date'

export const toReferee = (accountantReference: IncomeAccountantReference): Referee => ({
  id: accountantReference.subjectId,
  name: accountantReference.name,
  email: accountantReference.email,
  phone: accountantReference.mobile,
  jobTitle: accountantReference.jobRole ?? undefined,
})

export const toIncomeValue = (income: IncomeProperties): string =>
  `${income?.currency?.symbol ?? ''}${income.value} paid ${income.frequency} ${
    income.averageHoursAWeek ? `(${income.averageHoursAWeek} per week on average)` : ''
  }`

export const toReferenceDetails = (
  accountantReference: IncomeAccountantReference,
): Record<string, string> => ({
  ...(accountantReference.income
    ? { 'Declared income': toIncomeValue(accountantReference.income) }
    : {}),
  ...(accountantReference.incomeSource
    ? { 'Sources of income': accountantReference.incomeSource }
    : {}),
  ...(accountantReference.startDate
    ? {
        'Earliest date applicant began receiving the income': formatDate(
          parseDate(accountantReference.startDate),
        ),
      }
    : {}),
  ...(accountantReference.taxReturnYearPeriod
    ? { 'Tax return year': accountantReference.taxReturnYearPeriod }
    : {}),
  ...(accountantReference.incomeConfirmationType
    ? { 'Income confirmation type': accountantReference.incomeConfirmationType }
    : {}),
})
